
import { Component, Vue, Prop } from 'vue-property-decorator';

import MessageItem from '../MessageItem/index.vue';
@Component({
  name: 'MessageList',
  components: {
    MessageItem,
  },
})
class MessageList extends Vue {
  @Prop({ default: [] }) msgList:any;
  resendMsg(msg) {
    this.$emit('resendMsg', msg);
  }
}
export default MessageList;
